import client from './client';

export const getSummary = async () => {
  const { data } = await client.get('/analytics/summary');
  return data;
};

export const getEducatorBreakdown = async () => {
  const { data } = await client.get('/analytics/educators');
  return data;
};

export const getMonthlyActivity = async () => {
  const { data } = await client.get('/analytics/monthly');
  return data;
};

export const getEngagement = async () => {
  const { data } = await client.get('/analytics/engagement');
  return data;
};

export const getAtRisk = async () => {
  const { data } = await client.get('/analytics/at-risk');
  return data;
};

export const getAttendanceByClass = async (params = {}) => {
  const { data } = await client.get('/analytics/attendance/classes', { params });
  return data;
};

export const getAttendanceBySubject = async (params = {}) => {
  const { data } = await client.get('/analytics/attendance/subjects', { params });
  return data;
};

export const getSubmissionHeatmap = async (params = {}) => {
  const { data } = await client.get('/analytics/submission-heatmap', { params });
  return data;
};

export const getTermReport = async (params = {}) => {
  const { data } = await client.get('/reports/term', { params, responseType: 'blob' });
  return data;
};

export default {
  getSummary,
  getEducatorBreakdown,
  getMonthlyActivity,
  getEngagement,
  getAtRisk,
  getAttendanceByClass,
  getAttendanceBySubject,
  getSubmissionHeatmap,
  getTermReport,
};
